import React, { useEffect } from 'react';
import { MdClose } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getVehicleTrackingChangeLogs } from 'src/redux/Actions/VehicleTracking';

export default function VehicleTrackingChangeLog({ toggleChangeLog }) {
  const dispatch = useDispatch();
  const { vehicleTrackingNumber } = useParams();

  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const tenantOrganisationId = authReducer.userData.organisations?.id;

  const vehicleTrackingDataReducer = useSelector(
    (state) => state?.VehicleTrackingReducer,
  );

  useEffect(() => {
    dispatch(
      getVehicleTrackingChangeLogs(tenantOrganisationId, vehicleTrackingNumber),
    );
  }, [tenantOrganisationId, vehicleTrackingNumber]);

  const { vehicleTrackingChangedLogData } = vehicleTrackingDataReducer;

  return (
    <div className="page-layout div-flex-column right-form-layout">
      <div className="div-flex-row div-space-between div-align-center border-bottom horizontal-padding-10 pb-2">
        <span className="text-xxl text-bold">Changed Log</span>
        <button
          className="icon-btn-none"
          onClick={() => toggleChangeLog(false)}
          aria-label="Close drawer"
        >
          <MdClose size="24px" />
        </button>
      </div>

      <div
        className={`changed-log-container theme-scrollable-container-${themeColor}`}
      >
        <div className="div-flex-column rg-10 ">
          {vehicleTrackingChangedLogData?.map((logObj) => (
            <div key={logObj?.id} className="div-flex-column">
              <div className="div-flex-row div-align-start cg-10 change-log-item-bottom-padding border-bottom">
                <span
                  className={`status-dot ${
                    logObj?.action?.id === 3 ? 'dot-red' : 'dot-green'
                  }`}
                ></span>
                <div className="div-flex-column">
                  <span className="text-md text-semi-bold">
                    {logObj?.user} {logObj?.action?.name?.toLowerCase()}{' '}
                    <i>{logObj?.field_name}</i>
                  </span>
                  {logObj?.new_value ? (
                    <span className="text-md text-semi-bold">
                      from{' '}
                      <span className="status-pill red-none-border">
                        {logObj?.old_value}
                      </span>{' '}
                      to{' '}
                      <span className="status-pill green">
                        {logObj?.new_value}
                      </span>
                    </span>
                  ) : (
                    <span className="text-md text-semi-bold">
                      (deleted: {logObj?.old_value})
                    </span>
                  )}
                  <span className="text-sm text-grey text-semi-bold">
                    {logObj?.date_time}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
